module.exports = __webpack_public_path__ + "static/media/tap.65fb6f25.svg";